package empiresmp.feature.gallery.di

import empiresmp.feature.gallery.data.GalleryRepository
import empiresmp.feature.gallery.presentation.GalleryViewModel
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import kotlinx.serialization.json.Json

internal class GalleryModule {
    private val client = HttpClient(Js)
    private val json by lazy {
        Json {
            isLenient = true
            ignoreUnknownKeys = true
            prettyPrint = false
        }
    }

    fun createGalleryViewModel(): GalleryViewModel {
        return GalleryViewModel(
            galleryRepository = GalleryRepository(
                httpClient = client,
                json = json
            )
        )
    }
}
